import { ConfigReader } from '../config/configReader';

export interface TaxonomyTerm {
  termId: number;
  name: string;
  slug: string;
}

export interface TaxonomyResponse {
  skinType: TaxonomyTerm[];
  skinConcern: TaxonomyTerm[];
  ethicalStandard: TaxonomyTerm[];
  ingredient: TaxonomyTerm[];
}

export class ProductApi {
  private static readonly BASE_URL = ConfigReader.getApiDomain();

  static async getTaxonomy(): Promise<TaxonomyResponse> {
    const response = await fetch(`${ProductApi.BASE_URL}/product/taxonomy`);
    return response.json();
  }
}
